module.exports = __webpack_public_path__ + "static/img/img2.3b779ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/index/img2.png
// module id = VqzO
// module chunks = 3